export default __webpack_public_path__ + "static/media/us-ar.dc631941.svg";